import { useMemo }    from 'react';
import { objType }    from 'types';
import { showScores } from 'functions/set_data/show_app_buttons'

    const useShowScoresIcon = (
      hash:   { [key: string]: any },
      app:    objType,
      guest:  boolean,
      update: boolean,
    ) => {
  
     const showScoresButton = useMemo(() => {
  
      const appID  = (!!app.puzzle_id ? app.puzzle_id : !!app.uid ? `${ app.uid }` : app.lesson_id);
      const scores = showScores(guest, update, appID, hash);
     
      return !!(update && scores);
  
    },[hash, app, update, guest])

    return  showScoresButton 
  
  }
  
  export default useShowScoresIcon;
  
  